<template>
  <svg
    class="icon"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.5 4H13C8.58172 4 5 7.58172 5 12V35C5 39.4183 8.58172 43 13 43H35C39.4183 43 43 39.4183 43 35V20C43 15.5817 39.4183 12 35 12H24H5M35.5 27.5H35"
      stroke="black"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
</template>
